var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFF3F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2437_87941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 27C20.3869 27 22.6759 26.0516 24.3642 24.3642C26.0517 22.6759 27 20.3869 27 18C27 15.6131 26.0516 13.3241 24.3642 11.6358C22.6759 9.94829 20.3869 9 18 9C15.6131 9 13.3241 9.94837 11.6358 11.6358C9.94829 13.3241 9 15.6131 9 18C9.00318 20.3861 9.95157 22.6734 11.6391 24.3609C13.3266 26.0484 15.6141 26.9967 18 27ZM18 10.4852C19.993 10.4852 21.9049 11.2769 23.314 12.686C24.7231 14.0951 25.5148 16.007 25.5148 18C25.5148 19.993 24.7231 21.9049 23.314 23.314C21.9049 24.7231 19.993 25.5148 18 25.5148C16.007 25.5148 14.0951 24.7231 12.686 23.314C11.2769 21.9049 10.4852 19.993 10.4852 18C10.4868 16.0078 11.2801 14.0975 12.6882 12.6884C14.0973 11.2802 16.0076 10.4869 17.9998 10.4854L18 10.4852ZM18.7423 19.8649H17.2569L17.2577 13.4211H18.7431L18.7423 19.8649ZM18.7423 22.5787H17.2569L17.2577 21.0782H18.7431L18.7423 22.5787Z",
    fill: "#DF2935"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_87941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderError);
export default __webpack_public_path__ + "static/media/order_error.ea85b79d18e1b1f73285b9c5194a4200.svg";
export { ForwardRef as ReactComponent };